import React, { useEffect, useRef } from 'react';
export function Lookbook() {
  const sectionRef = useRef<HTMLElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current && imageRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const progress = rect.top - window.innerHeight / 2;
          imageRef.current.style.transform = `translateY(${progress * -0.15}px)`;
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative h-[70vh] md:h-screen overflow-hidden" data-id="element-130">
      <div ref={imageRef} className="absolute -inset-y-[20%] inset-x-0 transition-transform duration-100 will-change-transform" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/uAzgd5PnvAsT3TtHEQDZWj/IMG_9927.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-131" />
      <div className="absolute inset-0 bg-mocha/40" data-id="element-132" />

      <div className="relative h-full flex flex-col items-center justify-center text-center px-6" data-id="element-133">
        <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-cream mb-8" data-id="element-134">
          The new season, styled.
        </h2>
        <a href="https://shop.purepulsepilates.com" className="bg-cream text-espresso px-8 py-4 rounded-full uppercase tracking-widest text-sm hover:bg-rust hover:text-cream transition-colors min-h-[48px] flex items-center justify-center" data-id="element-135">
          SHOP THE LOOKBOOK
        </a>
      </div>
    </section>;
}